import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/nuxt-assets/icons/rocket-green2.svg")